import { render, staticRenderFns } from "./legendBox10.vue?vue&type=template&id=605fd5c8&scoped=true&"
import script from "./legendBox10.vue?vue&type=script&lang=js&"
export * from "./legendBox10.vue?vue&type=script&lang=js&"
import style0 from "./legendBox10.vue?vue&type=style&index=0&id=605fd5c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605fd5c8",
  null
  
)

export default component.exports